import { render, staticRenderFns } from "./MatrixTable.vue?vue&type=template&id=7e76cd0a&scoped=true"
import script from "./MatrixTable.vue?vue&type=script&lang=js"
export * from "./MatrixTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e76cd0a",
  null
  
)

export default component.exports